module.exports = __webpack_public_path__ + "static/img/sd.ae04c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sjcw/sd.png
// module id = dHur
// module chunks = 26